module.exports = __webpack_public_path__ + "img/concrete_porch_veranda_roof_detached.02e67267.jpg";